import { render, staticRenderFns } from "./SetUpVoice.vue?vue&type=template&id=3c9d77df&"
import script from "./SetUpVoice.vue?vue&type=script&lang=js&"
export * from "./SetUpVoice.vue?vue&type=script&lang=js&"
import style0 from "./SetUpVoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports